
<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
</style>


<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        รายการสินค้า
      </div>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="700px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="success" elevation="0" v-bind="attrs" v-on="on" dark>
            <v-icon left>mdi-file-plus</v-icon>สร้างสินค้า
          </v-btn>
        </template>
        <ProductForm :is_disable="is_disabled"></ProductForm>
      </v-dialog>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-layout column class="pt-5 d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        <v-data-table
          :headers="headers"
          :items="getIndex"
          disable-pagination
          class="elevation-1"
        >
          <template v-slot:item.PRICE="{ item }">
            {{ item.PRICE | delimeter }}
          </template>
          <template v-slot:item.detail="{ item }">
            <TableMenuProduct
              :TableData="item"
              :Page="'Quotation'"
              :ref="'Product_Menu'"
            ></TableMenuProduct>
          </template>
        </v-data-table>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import TableMenuProduct from "../components/TableMenuProduct";
import ProductForm from "./forms/ProductForm";
export default {
  components: {
    TableMenuProduct,
    ProductForm,
  },
  name: "Supply",
  data: () => ({
    dialog: false,
    is_disabled: false,
    product: [],
    headers: [
      { text: "ลำดับ", value: "id", align: "start" },
      { text: "ชื่อสินค้า", value: "NAME" },
      { text: "ราคาต่อหน่วย", value: "PRICE" },
      { text: "หมวดสินค้า", value: "CATEGORY" },
      { text: "", value: "detail" },
    ],
  }),
  watch: {},
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //let z = isNaN(x) == true ? '0.00' : x
      return x;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
  },
  computed: {
    getIndex() {
      // let data = this.product.filter((x) => {
      //   return x.PID != 28 && x.PID != 29 && x.PID != 30 && x.PID != 19 && x.PID != 20 && x.PID != 21 && x.PID != 106 && x.PID != 107 && x.PID != 108 && x.PID != 109 && x.PID != 115 && x.PID != 111 && x.PID != 112 && x.PID != 113 && x.PID != 114 && x.PID != 110 && x.PID != 40 && x.PID != 43 && x.PID != 44 && x.PID != 41 && x.PID != 42 && x.PID != 101
      // })
      let data = this.product
      return data.map((item, index, PRICE) => ({
        ...item,
        id: index + 1,

        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
  },
  methods: {
    listProduct() {
      this.$token_api
        .post("/data-products")
        .then((response) => {
          // console.log(response.data.data);
          this.product = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeMenu(item) {
      let pid = item.PID
      let result = pid == 28 || pid == 29 || pid == 30 || pid == 19 || pid == 20 || pid == 21 || pid == 106 || pid == 107 || pid == 108 || pid == 109 || pid == 115 || pid == 111 || pid == 112 || pid == 113 || pid == 114 || pid == 110 || pid == 40 || pid == 43 || pid == 44 || pid == 41 || pid == 42 || pid == 101
      return !result
    }
  },
  mounted() { },
  created() {
    this.$store.commit('Product/SET_IS_EDIT', false)
    this.listProduct();
  },
};
</script>


